import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import cssClasses from "./AllEvents.module.css";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";

//REDUX
import action from "../../Redux Store/actions";

//SUB-COMPONENTS
import Button from "../../Subcomponents/Button";

import FilterListIcon from '@mui/icons-material/FilterList';
// ICONS
import AddIcon from "@mui/icons-material/Add";
import SearchBar from "../../Subcomponents/Search";
import DropDown from "../../Subcomponents/DropDown";
import Datagrid from "../../Subcomponents/Datagrid";
import ThreeDotsMenu from "../../Subcomponents/ThreeDotsMenu";
import eventIcon from "../../Assets/Images/Common/Browser.svg";
import {
  getAllEvents,
  getEventLaunch,
  updateEvent,
} from "../../Services/Event";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../../Components/Icons/Dot";
import { errorTost, infoTost, successTost } from "../../Services/Toast";
import { Tooltip } from "@mui/material";

import {
  setAlotEventGlobalUnitAvailable,
  setAlotEventGlobalLeadAvailable,
} from "../../Services/StoredSessionData";
import { dismissLoader, presentLoader } from "../../Services/loader";
import EmptyListIcon from "../../Assets/Images/Common/NoSiteVisitsFound.svg";
import { Card } from "@mui/material";
import Calendar from "../../Assets/Images/Common/calendar.svg";
import ViewMore from "../../Assets/Images/Common/viewMoreIcon.svg";

import { cloneDeep, uniqBy } from "lodash";
import { useSelector } from "react-redux";
import { supabase } from "../../supabaseClient";
import PlusIcon from "../../Components/Icons/PlusIcon";
const useStyles = makeStyles((theme) => ({
  Tooltip: {
    "&.MuiTooltip-tooltip": {
      fontSize: "1.2rem",
    },
  },
}));

export default function AllEvents() {
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [filterBy, setFilterBy] = useState("All");
  const [pageMaintain, setPageMaintain] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [allEvents, setAllEvents] = useState([]);
  const [EventDurationData, setEventDurationData] = useState([]);
  const [search, setSearch] = useState("");
  const classes = useStyles();
  const [eventsPresent, setEventPresent] = useState(null);
  const [threeDotsMenuArray, setThreeDotsMenuArray] = useState([]);
  function goToEvent(value) {
    console.log("title", value.eventId);

    sessionStorage.setItem(
      "isEventLive",
      new Date(value.startDateTime).getTime() <= new Date().getTime() &&
      new Date(value.endDateTime).getTime() >= new Date().getTime()
    );


    if (JSON.parse(localStorage.getItem("user"))?.roleId?.accessibleTabs?.Event?.["View Details"]?.Inventory?.isAccessible) {
      navigate(`/home/Event/Details/${value.eventId}/Inventory`);
    } else if (JSON.parse(localStorage.getItem("user"))?.roleId?.accessibleTabs?.Event?.["View Details"]?.CP?.isAccessible) {
      navigate(`/home/Event/Details/${value.eventId}/CP`);
    } else if (JSON.parse(localStorage.getItem("user"))?.roleId?.accessibleTabs?.Event?.["View Details"]?.Sales?.isAccessible) {
      navigate(`/home/Event/Details/${value.eventId}/Sales`);
    } else if (JSON.parse(localStorage.getItem("user"))?.roleId?.accessibleTabs?.Event?.["View Details"]?.["Token Holders"]?.isAccessible) {
      navigate(`/home/Event/Details/${value.eventId}/TokenHolders`);
    } else if (JSON.parse(localStorage.getItem("user"))?.roleId?.accessibleTabs?.Event?.["View Details"]?.["Site Visit"]?.isAccessible) {
      navigate(`/home/Event/Details/${value.eventId}/SiteVisit`);
    } else if (JSON.parse(localStorage.getItem("user"))?.roleId?.accessibleTabs?.Event?.["View Details"]?.["Token Refund Requests"]?.isAccessible) {
      navigate(`/home/Event/Details/${value.eventId}/TokenRefundRequests`);
    } else if (JSON.parse(localStorage.getItem("user"))?.roleId?.accessibleTabs?.Event?.["View Details"]?.["Direct Allotment"]?.isAccessible) {
      navigate(`/home/Event/Details/${value.eventId}/DirectAllotment`);
    } else if (JSON.parse(localStorage.getItem("user"))?.roleId?.accessibleTabs?.Event?.["View Details"]?.["Bulk Token Refund"]?.isAccessible) {
      navigate(`/home/Event/Details/${value.eventId}/BulkTokenRefund`);
    } else {
      navigate(`/home/Event`);
    }

    // navigate(`/home/Event/Details/${value.eventId}/Inventory`);
    setAlotEventGlobalUnitAvailable(false);
    setAlotEventGlobalLeadAvailable(false);
    sessionStorage.setItem("GlobalLeadPreSelected", JSON.stringify(false));
  }

  const eventGridColums = [
    {
      field: "action",
      headerName: "",
      sortable: false,
      width: 100,
      renderCell: (params) => {
        let arr = [];
        if (
          JSON.parse(localStorage.getItem("user"))?.roleId?.accessibleTabs
            ?.Event["Configure Event"]?.isAccessible === true &&
          new Date(params.row.endDateTime).getTime() >= new Date().getTime()
        ) {
          arr.push("Configure Event");
        }
        if (
          JSON.parse(localStorage.getItem("user"))?.roleId?.accessibleTabs
            ?.Event["View Details"]?.isAccessible === true
        ) {
          arr.push("View Details");
        }
        if (
          JSON.parse(localStorage.getItem("user"))?.roleId?.accessibleTabs
            ?.Event["Edit Event"]?.isAccessible === true
        ) {
          arr.push("Edit Event");
        }
        return (
          <div className={cssClasses.actionDiv}>
            {/* {!params.row.isPublished ?
                            <div>
                                <Button btnName={"Publish"} style={{ backgroundColor: "#007FFF", color: "#FFFFFF", fontSize: "1.4rem" }} padding={"0.5rem 1rem"} clicked={() => { editEvent(params.row.eventId, 'publish'); setAllEvents((pre) => { pre[params.row.index].isPublished = true; return [...pre] }) }} />
                            </div>
                            :
                            <div>
                                <Button btnName={"Un-Publish"} style={{ backgroundColor: "#FFFFFF", color: "#007FFF", border: "1px solid #007FFF", fontSize: "1.4rem" }} padding={"0.5rem 1rem"} clicked={() => { editEvent(params.row.eventId, 'unpublish'); setAllEvents((pre) => { pre[params.row.index].isPublished = false; return [...pre] }) }} />
                            </div>
                        } */}
            {arr.length > 0 && (
              <div>
                <ThreeDotsMenu
                  list={arr}
                  selectedValue={(e) => {
                    selectedOption(e, params.row.eventId, params.row.title, params.row);
                  }}
                />
              </div>
            )}
          </div>
        );
      },
    },
    {
      field: "title",
      headerName: "Event",
      // disableColumnFilter: false,
      operator: '>', value: '2.5',
      sortable: true,
      width: 400,
      renderHeader: (params) => (
        <strong style={{
          display: "flex",
          alignItems: "center",
          gap: "1rem"
        }}>
          {'Event '}
          <span role="img" aria-label="enjoy" style={{ display: "flex" }}>
            <FilterListIcon />
          </span>
        </strong>
      ),
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              cursor: "pointer",
            }}
            onClick={() => {
              goToEvent(params.row);
            }}
          >
            {params.row.bannerImgUrl ? (
              <img
                style={{
                  width: "4rem",
                  height: "4rem",
                  objectFit: "cover",
                  borderRadius: "50%",
                }}
                src={
                  process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                  params.row.bannerImgUrl +
                  `?${Date.now()}`
                }
                alt=""
              />
            ) : (
              <div
                style={{
                  background: "#FDB022",
                  borderRadius: "50%",
                  textAlign: "center",
                }}
              >
                <img
                  style={{ margin: "0.8rem 1rem 0.4rem 1rem" }}
                  src={eventIcon}
                  alt=""
                />
              </div>
            )}
            <div>
              <Tooltip
                className={classes.Tooltip}
                placement="bottom-start"
                title={<p style={{ fontSize: "1.2rem" }}>{params.row.title}</p>}
              >
                <p style={{ fontSize: "1.4rem" }}>{params.row.title}</p>
              </Tooltip>
            </div>
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: "Event Type",
      sortable: false,
      width: 220,
      renderCell: (params) => {
        return (
          <LeadStatusChip
            label={new Date(params.row.endDateTime).getTime() < new Date().getTime()
              ? "Closed"
              : new Date(params.row.startDateTime).getTime() <= new Date().getTime() && new Date(params.row.endDateTime).getTime() >= new Date().getTime()
                ? "Live"
                : "Upcoming"
            }
            style={
              new Date(params.row.endDateTime).getTime() < new Date().getTime()
                ? { color: "#B42318", backgroundColor: "#FEF3F2" }
                : new Date(params.row.startDateTime).getTime() <=
                  new Date().getTime() &&
                  new Date(params.row.endDateTime).getTime() >=
                  new Date().getTime()
                  ? { color: "#027A48", backgroundColor: "#ECFDF3" }
                  : { color: "#B54708", backgroundColor: "#FFFAEB" }
            }
            icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
          />
        );
      },
    },
    {
      field: "startDateTime",
      headerName: "Start Date Time",
      sortable: false,
      width: 250,
    },
    {
      field: "endDateTime",
      headerName: "End Date Time",
      sortable: false,
      width: 250,
    },
    {
      field: "isPublished",
      headerName: "Status",
      sortable: false,
      width: 200,
      renderCell: (params) => {
        return (
          <LeadStatusChip
            style={{
              color: params.row.isPublished
                ? "rgb(2, 122, 72)"
                : "rgb(180, 35, 24)",
              backgroundColor: params.row.isPublished
                ? "rgb(236, 253, 243)"
                : "rgb(254, 243, 242)",
            }}
            label={params.row.isPublished ? "Published" : "Not Published"}
            icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
          />
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(action.activeMenu("event"));
  }, []);
  //**Three dot menu array */
  useEffect(() => {
    let arr = [];
    if (
      JSON.parse(localStorage.getItem("user"))?.roleId?.accessibleTabs?.Event?.[
        "Configure Event"
      ]?.isAccessible === true
      //     &&
      //   new Date(params.row.endDateTime).getTime() >= new Date().getTime()
    ) {
      arr.push("Configure Event");
    }
    if (
      JSON.parse(localStorage.getItem("user"))?.roleId?.accessibleTabs?.Event?.[
        "View Details"
      ]?.isAccessible === true
    ) {
      console.log("subTab-access", JSON.parse(localStorage.getItem("user"))?.roleId?.accessibleTabs?.Event?.[
        "View Details"
      ])
      arr.push("View Details");
    }
    if (
      JSON.parse(localStorage.getItem("user"))?.roleId?.accessibleTabs?.Event?.[
        "Edit Event"
      ]?.isAccessible === true
    ) {
      arr.push("Edit Event");
    }
    setThreeDotsMenuArray(arr);
  }, []);

  useEffect(() => {
    if (allEvents.length === 0) {
      presentLoader();
      getEventLaunch(loggedInUser.userId, loggedInUser)
        .then((launchSalesRelationRes) => {
          dismissLoader();
          console.log({ launchSalesRelationRes });
          let eventArr = [];
          if (!JSON.parse(localStorage.getItem('user')).roleId.accessibleTabs.Event["Show Events"] || JSON.parse(localStorage.getItem('user')).roleId.accessibleTabs.Event["Show Events"].show === 'Assinged Users') {
            launchSalesRelationRes.data.forEach((el) => {
              eventArr.push(el.launchId.eventId);
            });
            console.log({ eventArr });
            eventArr.forEach((ele, index) => {
              ele.show = true;
              ele.id = ele.eventId;
              ele.startDateTime =
                new Date(ele.startDateTime).toDateString() +
                "," +
                new Date(ele.startDateTime).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                });
              ele.endDateTime =
                new Date(ele.endDateTime).toDateString() +
                "," +
                new Date(ele.endDateTime).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                });
              ele.index = index;
            });
          } else {
            eventArr = launchSalesRelationRes.data;
            // Sorting function
            const sortByStatus = (eventA, eventB) => {
              const getStatusOrder = (event) => {
                if (new Date(event.endDateTime).getTime() < new Date().getTime()) {
                  return 3; // Closed
                } else if (
                  new Date(event.startDateTime).getTime() <= new Date().getTime() &&
                  new Date(event.endDateTime).getTime() >= new Date().getTime()
                ) {
                  return 1; // Live
                } else {
                  return 2; // Upcoming
                }
              };

              const statusOrderA = getStatusOrder(eventA);
              const statusOrderB = getStatusOrder(eventB);

              return statusOrderA - statusOrderB;
            };

            // Sort events based on status
            eventArr.sort(sortByStatus);
            eventArr.forEach((ele, index) => {
              ele.show = true;
              ele.id = ele.eventId;
              ele.startDateTime =
                new Date(ele.startDateTime).toDateString() +
                "," +
                new Date(ele.startDateTime).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                });
              ele.endDateTime =
                new Date(ele.endDateTime).toDateString() +
                "," +
                new Date(ele.endDateTime).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                });
              ele.index = index;
            })
          }
          setAllEvents(uniqBy(eventArr, "eventId"));
          console.log('AllEvents', uniqBy(eventArr, "eventId"))
          setEventDurationData(eventArr);
          if (eventArr.length > 0) {
            setEventPresent(true);
          } else {
            setEventPresent(false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
      // getAllEvents("All", "", 0, 20)
      //   .then((resp) => {

      //     console.log(resp);
      //     resp.data.forEach((ele, index) => {

      //       ele.show = true;
      //       ele.id = ele.eventId;
      //       ele.startDateTime =
      //         new Date(ele.startDateTime).toDateString() +
      //         "," +
      //         new Date(ele.startDateTime).toLocaleTimeString([], {
      //           hour: "2-digit",
      //           minute: "2-digit",
      //         });
      //       ele.endDateTime =
      //         new Date(ele.endDateTime).toDateString() +
      //         "," +
      //         new Date(ele.endDateTime).toLocaleTimeString([], {
      //           hour: "2-digit",
      //           minute: "2-digit",
      //         });
      //       ele.index = index;
      //     });
      //     setAllEvents(resp.data);
      //     setEventDurationData(resp.data);
      //     if (resp.data.length > 0) {
      //       setEventPresent(true);
      //     } else {
      //       setEventPresent(false);
      //     }
      //     dismissLoader();
      //   })
      //   .catch((err) => {
      //     dismissLoader();
      //     console.log(err);
      //   });
    } else {
      if (search !== "") {
        // presentLoader()
        // getAllEvents(filterBy, search, 0, 20).then((resp) => {
        //     console.log(resp)
        //     resp.data.forEach((ele, index) => {
        //         ele.id = ele.eventId; ele.startDateTime = new Date(ele.startDateTime).toDateString() + ',' +
        //             new Date(ele.startDateTime).toLocaleTimeString([], {
        //                 hour: "2-digit",
        //                 minute: "2-digit",
        //             }); ele.endDateTime = new Date(ele.endDateTime).toDateString() + ',' +
        //                 new Date(ele.endDateTime).toLocaleTimeString([], {
        //                     hour: "2-digit",
        //                     minute: "2-digit",
        //                 }); ele.index = index
        //     })
        //     setAllEvents(resp.data)
        //     dismissLoader()
        // }).catch((err) => {
        //     dismissLoader()
        //     console.log(err)
        // })
        // allEvents.forEach(())
        setAllEvents((pre) => {
          pre.forEach((ele) => {
            if (filterBy === "All") {
              if (ele.title.toUpperCase().includes(search.toUpperCase())) {
                ele.show = true;
              } else {
                ele.show = false;
              }
            } else if (filterBy === "Live") {
              if (
                new Date(ele.startDateTime).getTime() <= new Date().getTime() &&
                new Date(ele.endDateTime).getTime() >= new Date().getTime() &&
                ele.title.toUpperCase().includes(search.toUpperCase())
              ) {
                ele.show = true;
              } else {
                ele.show = false;
              }
            } else if (filterBy === "Upcoming") {
              if (
                new Date(ele.startDateTime).getTime() > new Date().getTime() &&
                ele.title.toUpperCase().includes(search.toUpperCase())
              ) {
                ele.show = true;
              } else {
                ele.show = false;
              }
            } else if (filterBy === "Closed") {
              if (
                new Date(ele.endDateTime).getTime() < new Date().getTime() &&
                ele.title.toUpperCase().includes(search.toUpperCase())
              ) {
                ele.show = true;
              } else {
                ele.show = false;
              }
            }
          });
          return [...pre];
        });
      } else {
        setAllEvents((pre) => {
          pre.forEach((ele) => {
            if (filterBy === "All") {
              ele.show = true;
            } else if (filterBy === "Live") {
              if (
                new Date(ele.startDateTime).getTime() <= new Date().getTime() &&
                new Date(ele.endDateTime).getTime() >= new Date().getTime()
              ) {
                ele.show = true;
              } else {
                ele.show = false;
              }
            } else if (filterBy === "Upcoming") {
              if (
                new Date(ele.startDateTime).getTime() > new Date().getTime()
              ) {
                ele.show = true;
              } else {
                ele.show = false;
              }
            } else if (filterBy === "Closed") {
              if (new Date(ele.endDateTime).getTime() < new Date().getTime()) {
                ele.show = true;
              } else {
                ele.show = false;
              }
            }
          });
          return [...pre];
        });
      }
    }
  }, [filterBy, search, pageNumber]);

  function editEvent(id, type) {
    const obj =
      type === "publish" ? { isPublished: true } : { isPublished: false };
    updateEvent(id, obj)
      .then((resp) => {
        if (type === "publish") successTost("Event published successfully");
        else successTost("Event unpublished successfully");
      })
      .catch((err) => {
        errorTost("Something went wrong please try again later");
      });
  }

  function selectedOption(e, eventId, title, value) {
    console.log("eventID", eventId)
    console.log("value---->", value)
    if (e === "Edit Event") {

      localStorage.setItem("event", eventId);
      navigate("/home/Event/AddEvent");
    } else if (e === "Configure Event") {
      navigate(`/home/Event/ConfigureEvent/${eventId}`);
    } else if (e === "View Details") {
      // navigate(`/home/Event/${eventId}/ConfigureEvent`)
      console.log("subTab-access", JSON.parse(localStorage.getItem("user"))?.roleId?.accessibleTabs?.Event?.[
        "View Details"
      ])
      sessionStorage.setItem(
        "isEventLive",
        new Date(value.startDateTime).getTime() <= new Date().getTime() &&
        new Date(value.endDateTime).getTime() >= new Date().getTime()
      )
      sessionStorage.setItem("GlobalLeadPreSelected", JSON.stringify(false));
      if (JSON.parse(localStorage.getItem("user"))?.roleId?.accessibleTabs?.Event?.["View Details"]?.Inventory?.isAccessible) {
        navigate(`/home/Event/Details/${eventId}/Inventory`);
      } else if (JSON.parse(localStorage.getItem("user"))?.roleId?.accessibleTabs?.Event?.["View Details"]?.CP?.isAccessible) {
        navigate(`/home/Event/Details/${eventId}/CP`);
      } else if (JSON.parse(localStorage.getItem("user"))?.roleId?.accessibleTabs?.Event?.["View Details"]?.Sales?.isAccessible) {
        navigate(`/home/Event/Details/${eventId}/Sales`);
      } else if (JSON.parse(localStorage.getItem("user"))?.roleId?.accessibleTabs?.Event?.["View Details"]?.["Token Holders"]?.isAccessible) {
        navigate(`/home/Event/Details/${eventId}/TokenHolders`);
      } else if (JSON.parse(localStorage.getItem("user"))?.roleId?.accessibleTabs?.Event?.["View Details"]?.["Site Visit"]?.isAccessible) {
        navigate(`/home/Event/Details/${eventId}/SiteVisit`);
      } else if (JSON.parse(localStorage.getItem("user"))?.roleId?.accessibleTabs?.Event?.["View Details"]?.["Token Refund Requests"]?.isAccessible) {
        navigate(`/home/Event/Details/${eventId}/TokenRefundRequests`);
      } else if (JSON.parse(localStorage.getItem("user"))?.roleId?.accessibleTabs?.Event?.["View Details"]?.["Direct Allotment"]?.isAccessible) {
        navigate(`/home/Event/Details/${eventId}/DirectAllotment`);
      } else if (JSON.parse(localStorage.getItem("user"))?.roleId?.accessibleTabs?.Event?.["View Details"]?.["Bulk Token Refund"]?.isAccessible) {
        navigate(`/home/Event/Details/${value.eventId}/BulkTokenRefund`);
      } else {
        navigate(`/home/Event`);
      }
      setAlotEventGlobalUnitAvailable(false);
      setAlotEventGlobalLeadAvailable(false);
      // navigate(`/home/Event/Details/${title}/Cp&Sales`)
    }
  }

  function pageChanged(e) {
    console.log(e);
    setPageMaintain(e);
    if (pageNumber < e) {
      setPageNumber(e);
    }
  }

  return (
    <div className={cssClasses.mainContainer}>
      <div className={cssClasses.header}>
        <div className={cssClasses.titleWrapper}>
          <div className={cssClasses.title}>
            <p>All Events</p>
          </div>
          <div className={cssClasses.btnWrapper}>
            {JSON.parse(localStorage.getItem("user")).roleId?.accessibleTabs
              ?.Event?.["Add Event"].isAccessible && (
                <Button
                  clicked={() => {
                    localStorage.setItem("event", "");
                    navigate("/home/Event/AddEvent");
                  }}
                  btnName={"Add Event"}
                  btnIcon={<PlusIcon />}
                  style={{
                    color: "#fff",
                    backgroundColor: "#1570EF",
                    fontSize: "1.4rem",
                    lineHeight: "2rem",
                    fontFamily: "Roboto-Regular",
                  }}
                  padding={"0.8rem 2.6rem"}
                  iconPosition={"left"}
                />
              )}
          </div>
        </div>
        {/* <div className={}>
                    <div>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                    </div>
                </div> */}
      </div>
      <div className={cssClasses.content}>
        {/* <div className={cssClasses.totalEvents}>
          {allEvents.length > 1 ? (
            <p>
              {
                allEvents.filter((ele) => {
                  return ele.show;
                }).length
              }{" "}
              Events
            </p>
          ) : (
            <p>
              {
                allEvents.filter((ele) => {
                  return ele.show;
                }).length
              }{" "}
              Event
            </p>
          )}
        </div> */}
        <div className={cssClasses.actionWrapper}>
          {/* <div className={cssClasses.filterWrapper}>
            <div className={cssClasses.label}>
              <p>Filter by</p>
            </div>
            <div className={cssClasses.dropdownWrapper}>
              <DropDown
                onChangeSelect={(e) => {
                  setFilterBy(e);
                }}
                selectedValue={filterBy}
                style={{ selectedColor: "#175CD3", background: "#E8F0FE" }}
                list={["All", "Live", "Upcoming", "Closed"]}
              />
            </div>
          </div> */}
          <div className={cssClasses.totalEvents}>
            {allEvents.length > 1 ? (
              <p>
                {
                  allEvents.filter((ele) => {
                    return ele.show;
                  }).length
                }{" "}
                Events
              </p>
            ) : (
              <p>
                {
                  allEvents.filter((ele) => {
                    return ele.show;
                  }).length
                }{" "}
                Event
              </p>
            )}
          </div>
          <div className={cssClasses.filtersort}>
            <div className={cssClasses.filterWrapper}>
              <div className={cssClasses.label}>
                <p>Filter by</p>
              </div>
              <div className={cssClasses.dropdownWrapper}>
                <DropDown
                  onChangeSelect={(e) => {
                    setFilterBy(e);
                  }}
                  selectedValue={filterBy}
                  style={{ selectedColor: "#175CD3", background: "#E8F0FE" }}
                  list={["All", "Live", "Upcoming", "Closed"]}
                />
              </div>
            </div>
            {/* <div className={cssClasses.searchWrapper}> */}
            <SearchBar
              placeholder={"Search by event name"}
              search={(e) => {
                setSearch(e.target.value);
              }}
              id={"eventSearchBar"}
            />
          </div>
        </div>
        <div className={cssClasses.gridWrapper}>
          {window.innerWidth > 820 && (
            <Datagrid
              pageChanged={pageChanged}
              hideFooter={false}
              columns={eventGridColums}
              rows={allEvents.filter((ele) => {
                return ele.show;
              })}
            />
          )}
          {eventsPresent && window.innerWidth <= 820 && (
            <div className={cssClasses.eventsWrapper}>
              {allEvents
                .filter((ele) => {
                  return ele.show;
                })
                .map((event) => (
                  <Card className={cssClasses.eventWrap}>
                    <div className={cssClasses.eventInfo}>
                      <div className={cssClasses.eventImg}>
                        {event && event.bannerImgUrl ? (
                          <img
                            src={
                              process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                              event.bannerImgUrl
                            }
                            alt="Event"
                          />
                        ) : (
                          <div
                            style={{
                              background: "#FDB022",
                              borderRadius: "50%",
                              textAlign: "center",
                            }}
                          >
                            <img
                              style={{ margin: "0.8rem 1rem 0.4rem 1rem" }}
                              src={eventIcon}
                              alt=""
                            />
                          </div>
                          // <img src={EventDefaultImg} alt="Event" />
                        )}
                      </div>
                      <div className={cssClasses.eventData}>
                        <div
                          style={{
                            display: "flex",
                            // gap: "0.2rem",
                            justifyContent: "space-between",

                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <LeadStatusChip
                            label={
                              new Date(event.endDateTime).getTime() <
                                new Date().getTime()
                                ? "Closed"
                                : new Date(event.startDateTime).getTime() <=
                                  new Date().getTime() &&
                                  new Date(event.endDateTime).getTime() >=
                                  new Date().getTime()
                                  ? "Live"
                                  : "Upcoming"
                            }
                            style={
                              new Date(event.endDateTime).getTime() <
                                new Date().getTime()
                                ? {
                                  color: "#B42318",
                                  backgroundColor: "#FEF3F2",
                                }
                                : new Date(event.startDateTime).getTime() <=
                                  new Date().getTime() &&
                                  new Date(event.endDateTime).getTime() >=
                                  new Date().getTime()
                                  ? {
                                    color: "#027A48",
                                    backgroundColor: "#ECFDF3",
                                  }
                                  : {
                                    color: "#B54708",
                                    backgroundColor: "#FFFAEB",
                                  }
                            }
                            icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
                          />
                          <LeadStatusChip
                            label={
                              event.isPublished ? "Published" : "Not Published"
                            }
                            style={
                              event.isPublished
                                ? {
                                  color: "#027A48",
                                  backgroundColor: "#ECFDF3",
                                }
                                : {
                                  color: "#B42318",
                                  backgroundColor: "#FEF3F2",
                                }
                            }
                            icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
                          />
                          <div>
                            <ThreeDotsMenu
                              list={threeDotsMenuArray}
                              selectedValue={(e) => {
                                selectedOption(e, event.eventId, event.title, event);
                              }}
                            />
                          </div>
                        </div>
                        <div className={cssClasses.eventName}>
                          {event.title}
                        </div>
                        <div className={cssClasses.eventLaunches}>
                          {/* {event.launch.map((launch, index) => (
                                <div className={cssClasses.launchWrap}>
                                  <div className={cssClasses.launchIcon}>
                                  </div>
                                  <div className={cssClasses.launchLoc}>
                                    {launch.launchtitle}, {launch.addressline2}
                                  </div>

                                </div>
                              ))} */}
                        </div>
                        <div className={cssClasses.eventDate}>
                          <div className={cssClasses.launchIcon}>
                            <img src={Calendar} alt="Event Schedule" />
                          </div>
                          <div className={cssClasses.launchLoc}>
                            From:
                            <span className={cssClasses.bold}>
                              {new Date(event.startDateTime).toDateString()},{" "}
                              {new Date(event.startDateTime).toLocaleTimeString(
                                [],
                                {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                }
                              )}
                            </span>
                            To:
                            <span className={cssClasses.bold}>
                              {new Date(event.endDateTime).toDateString()},{" "}
                              {new Date(event.endDateTime).toLocaleTimeString(
                                [],
                                {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                }
                              )}
                            </span>
                          </div>
                        </div>
                        {/* <div className={cssClasses.viewMore}>
                                <img
                                  src={ViewMore}
                                  style={{ cursor: "pointer" }}
                                  alt={"More"}
                                  onClick={() => {
                                    navigate(`/home/Queue/${event.eventId}`);
                                  }}
                                />
                              </div> */}
                      </div>
                    </div>
                  </Card>
                ))}
            </div>
          )}
          {eventsPresent === false && window.innerWidth <= 820 && (
            <div className={cssClasses.noDataMsg}>
              <div className={cssClasses.emptyIcon}>
                <img src={EmptyListIcon} alt="No Events" />
              </div>
              <div className={cssClasses.emptyTitle}>No Events Found</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
